// PostHog — session replay, console/network capture, usage analytics (EU cloud).
// Replays are viewable in the PostHog dashboard; the bug reporter attaches a
// replay link to every report so devs can watch exactly what happened.
import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST;

const SENSITIVE = /password|sort.?code|account.?number|iban|secret|token|card/i;

export const initPostHog = () => {
  if (!KEY || !HOST) return;
  posthog.init(KEY, {
    api_host: HOST,
    defaults: "2025-05-24", // SPA pageviews on history change
    capture_pageleave: true,
    capture_performance: true, // network timings in replays
    capture_exceptions: true, // uncaught JS errors -> PostHog error tracking
    enable_recording_console_log: true,
    person_profiles: "identified_only",
    session_recording: {
      maskAllInputs: false, // internal staff tool — keep inputs visible for debugging
      maskInputOptions: { password: true },
      maskInputFn: (text, element) => {
        const hint = `${element?.name || ""} ${element?.id || ""} ${element?.placeholder || ""} ${
          element?.getAttribute?.("data-testid") || ""
        }`;
        return SENSITIVE.test(hint) ? "*".repeat(text.length) : text;
      },
    },
  });
};

// Link events + replays to the logged-in portal user
export const identifyPostHogUser = (user) => {
  if (!KEY || !user?.email) return;
  posthog.identify(user.email, {
    email: user.email,
    name: user.name,
    role: user.role,
    team: user.team,
    is_dev_bypass: !!user.is_dev_bypass,
  });
};

export const resetPostHog = () => {
  if (!KEY) return;
  posthog.reset();
};

// Replay URL for the current session (attached to bug reports)
export const getSessionReplayUrl = () => {
  if (!KEY) return null;
  try {
    return posthog.get_session_replay_url({ withTimestamp: true, timestampLookBack: 30 }) || null;
  } catch {
    return null;
  }
};

export default posthog;
